import { render, staticRenderFns } from "./employees-item-match.vue?vue&type=template&id=50549f5a"
import script from "./employees-item-match.vue?vue&type=script&lang=js"
export * from "./employees-item-match.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports